import { Page } from '../../Models';
import { StreakInfoProps } from '../../components/StreakInfo/StreakLogic';

export enum BadgeId {
  egg = 'egg-badge',
  sneaker = 'sneaker-badge',
  cupcake = 'cupcake-badge',
  yoda = 'yoda-badge',
  wings = 'wings-badge',
  icecream = 'icecream-badge',

  kumamon = 'kumamon-badge',
  coffee = 'coffee-badge',
  monster = 'monster-badge',
  gameboy = 'gameboy-badge',
  mask = 'mask-badge',
  iceberg = 'iceberg-badge',

  pigeon = 'pigeon-badge',
  donut = 'donut-badge',
  book = 'book-badge',
  paperPlane = 'paper-plane-badge',
  rocket = 'rocket-badge',
  leaf = 'leaf-badge',

  dove = 'dove-badge',
  tv = 'tv-badge',
  rainbow = 'rainbow-badge',
  submarine = 'submarine-badge',
  cocktail = 'cocktail-badge',
  bauble = 'bauble-badge',

  bomb = 'bomb-badge',
  doge = 'doge-badge',
}

export abstract class Badge {
  public readonly id: BadgeId;
}

export interface BadgesStats {
  readonly pagesCount: number;
  readonly wordsCount: number;
  readonly streakInfo: StreakInfoProps;
  readonly todaysPage?: Page;
}



// WEBPACK FOOTER //
// ./src/containers/Badges/Models.ts